import React, { useEffect, useState, useMemo } from "react";
import PropTypes from "prop-types";
import withRouter from "components/Common/withRouter";
import { isEmpty } from "lodash";
import { nanoid } from "nanoid";

import {
  Button,
  Card,
  CardBody,
} from "reactstrap";
import { getOrders as onGetOrders } from "store/actions";

// Other Details Modal
import EcommerceOrdersModal from "../Ecommerce/EcommerceOrders/EcommerceOrdersModal";

import {
  Date,
  Text,
  Result,
  AbstractLength,
  Rating,
  APICost,
  TimeStamp,
} from "./LatestTransactionCol";

import TableContainer from "../../components/Common/TableContainer";

console.log('LatestTransaction Remounting');

const LatestTransaction = props => {

  const { interactionList } = props;

  // For Other Details Modal
  const [modal1, setModal1] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);

  const latestTransaction = useMemo(() => interactionList.map((interaction) => ({
    interactQuestion: interaction.text,
    interactResponse: interaction.abstracttext,
    abstractLength: interaction.abstractlength,
    apiCost: (interaction.apiCost
      ?interaction.apiCost
      :Number((interaction.text.length+interaction.abstracttext.length)/1000*1.2*0.002*30)).toFixed(4),
    timeStamp: interaction.time,
    otherDetail: (interaction.otherDetail?interaction.otherDetail:"-"),
  })), [interactionList]);

  const handleRowClick = (rowData) => {
    setSelectedRowData(rowData);
  };

  const toggleViewModal = () => setModal1(!modal1);

  const columns = useMemo(
    () => [
      {
        Header: "#",
        filterable: false,
        disableFilters: true,
        width: 20,
        Cell: cellProps => {
          return <input type="checkbox" className="form-check-input" />;
        },
      },
      {
        Header: "原始文本",
        accessor: "interactQuestion",
        disableFilters: true,
        filterable: false,
        width: 500,
        Cell: cellProps => {
          return <Text {...cellProps} />;
        },
      },
      {
        Header: "摘要生成結果",
        accessor: "interactResponse",
        disableFilters: true,
        filterable: false,
        width: 500,
        Cell: cellProps => {
          return <Result {...cellProps} />;
        },
      },
      {
        Header: "摘要字數限制",
        accessor: "abstractLength",
        disableFilters: true,
        filterable: false,
        width: 150,
        Cell: cellProps => {
          return <AbstractLength {...cellProps} />;
        },
      },
      {
        Header: "API 計費",
        accessor: "apiCost",
        disableFilters: true,
        filterable: false,
        width: 100,
        Cell: cellProps => {
          return <APICost {...cellProps} />;
        },
      },
      {
        Header: "時間標記",
        accessor: "timeStamp",
        disableFilters: true,
        width: 150,
        Cell: cellProps => {
          return <TimeStamp {...cellProps} />;
        },
      },
      {
        Header: "其他",
        accessor: "otherDetail",
        disableFilters: true,
        width: 120,
        Cell: cellProps => {
          return (
            <Button
              type="button"
              color="primary"
              className="btn-sm btn-rounded"
              onClick={toggleViewModal}
            >
              檢視細節
            </Button>
          );
        },
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <EcommerceOrdersModal isOpen={modal1} toggle={toggleViewModal} selectedRowData={selectedRowData}/>
      <Card>
        <CardBody>
          <div className="mb-4 h4 card-title">摘要紀錄</div>
            <TableContainer
              columns={columns}
              data={latestTransaction}
              isGlobalFilter={true}
              isAddOptions={false}
              customPageSize={5}
              onRowClick={handleRowClick}
            />
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

LatestTransaction.propTypes = {
  orders: PropTypes.array,
  onGetOrders: PropTypes.func,
};

export default withRouter(LatestTransaction);
